export const BORDER_BOTTOM = 'Bottom'
export const BORDER_TOP = 'Top'
export const OUTLINE = 2
